(function () {
  function getIds(value) {
    return String(value || '')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);
  }

  function hasStoqPreorder(variantId) {
    const getSellingPlan = window._RestockRocket?.getSellingPlan;
    const numericVariantId = Number(variantId);

    if (typeof getSellingPlan !== 'function' || !Number.isSafeInteger(numericVariantId)) return false;

    try {
      return Boolean(getSellingPlan(numericVariantId));
    } catch (error) {
      console.error('[product card availability] Unable to read the STOQ selling plan.', error);
      return false;
    }
  }

  function updateBadge(badge) {
    const variantIds = getIds(badge.dataset.availabilityVariantIds);
    if (!variantIds.length) return;

    const availableVariantIds = new Set(getIds(badge.dataset.availabilityAvailableVariantIds));
    const preorderVariantIds = new Set(getIds(badge.dataset.availabilityServerPreorderVariantIds));
    const hideAllInStock = badge.dataset.availabilityHideAllInStock === 'true';

    variantIds.forEach((variantId) => {
      if (hasStoqPreorder(variantId)) {
        availableVariantIds.add(variantId);
        preorderVariantIds.add(variantId);
      }
    });

    const hasInStockVariant = [...availableVariantIds].some((variantId) => !preorderVariantIds.has(variantId));
    const isAllInStock = hideAllInStock
      && availableVariantIds.size === variantIds.length
      && preorderVariantIds.size === 0;
    let state = '';

    if (isAllInStock) {
      badge.hidden = true;
      badge.dataset.availabilityBadge = '';
      badge.classList.remove(
        'product-availability-badge--in-stock',
        'product-availability-badge--preorder',
        'product-availability-badge--out-of-stock'
      );
      badge.textContent = '';
      return;
    }

    if (hasInStockVariant) {
      state = 'in-stock';
    } else if (preorderVariantIds.size > 0) {
      state = 'preorder';
    } else {
      state = 'out-of-stock';
    }

    badge.hidden = false;
    badge.dataset.availabilityBadge = state;
    badge.classList.remove(
      'product-availability-badge--in-stock',
      'product-availability-badge--preorder',
      'product-availability-badge--out-of-stock'
    );
    badge.classList.add(`product-availability-badge--${state}`);
    badge.textContent = badge.dataset[`availabilityLabel${state.replace(/(^|-)([a-z])/g, (_, separator, letter) => letter.toUpperCase())}`] || '';
  }

  function updateBadges() {
    if (typeof window._RestockRocket?.getSellingPlan !== 'function') return;

    document.querySelectorAll('[data-availability-variant-ids]').forEach(updateBadge);
  }

  function scheduleUpdate() {
    window.setTimeout(updateBadges, 0);
    window.setTimeout(updateBadges, 350);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateBadges, { once: true });
  } else {
    updateBadges();
  }

  window.addEventListener('stoq:loaded', scheduleUpdate);
  document.addEventListener('stoq:product-changed', scheduleUpdate);
  document.addEventListener('product-card-availability:refresh', scheduleUpdate);
})();
